import { createSelector, createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { generateSearchParams } from 'utils/helpers/fetch';

const initialState = {
  error: '',
  pending: false,
  recipientsList: [],
};

const reducers = {
  fetchRecipientsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchRecipientsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchRecipientsSuccess(state, { payload }) {
    return R.assoc('recipientsList', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'recipients',
  reducers,
});

const { fetchRecipientsPending, fetchRecipientsSuccess, fetchRecipientsError } = actions;

// Selectors
const recipientsSelector = state => state.pto.recipients.recipientsList;

export const getRecipientsOptions = createSelector(recipientsSelector, recipients =>
  recipients.map(({ customerIdName, customerName }) => ({
    label: `${customerIdName} ${customerName}`,
    value: `${customerIdName}`,
  }))
);

// Actions
let fetchController;
export function fetchRecipients() {
  return (dispatch, getState) => {
    const { currentAffiliate } = getState().pto.searchPtos;
    const formattedAffiliate = currentAffiliate
      ? {
          affiliate: {
            companyCustomerIdName: currentAffiliate.customerIdName,
            dataCompanyId: currentAffiliate.dataCompanyId,
          },
        }
      : null;
    const paramString = qs.stringify(
      generateSearchParams(getState().pto.searchPtoFilters, formattedAffiliate),
      { allowDots: true, encode: false }
    );
    dispatch(fetchRecipientsPending(true));
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    http
      .get(`/product-transfer-orders/get-unique-recipients-list?${paramString}`, { signal })
      .then(res => {
        dispatch(fetchRecipientsError(''));
        dispatch(fetchRecipientsSuccess(res.data));
        dispatch(fetchRecipientsPending(false));
      });
  };
}

export default reducer;
